import { useGraphInstance } from "@antv/xflow"
import { useMemo } from "react"
import { NodeShapes } from "../../../services/modal"
import { LineType } from "../../../constant"
import { Tabs } from "antd"
import { TableType, UnitTable } from "./UnitTable"
import { useReactState } from "@/components/FlowSheetEditor/hooks/useReactState"
import { StreamUnitTable } from "./StreamTable"

export const AllUnitsPanel = () => {
  const graph = useGraphInstance()
  const reloadState = useReactState(1)

  const data = useMemo(() => {
    if (!graph) return {
      nodes: [],
      edges: [],
    }
    const nodes = graph.getNodes().filter(item => item.shape === NodeShapes.SvgNode)
    const edges = graph.getEdges().filter(item => {
      const data = item.getData();
      return data.type === LineType.FlowLine
    })
    return {
      nodes,
      edges
    }
  }, [graph, reloadState])

  const reload = () => {
    reloadState.setValue(reloadState.value + 1)
  }

  const tabs = [
    {
      key: '1',
      label: 'Equipments',
      children: <UnitTable units={data?.nodes} type={TableType.Node} reload={reload} />,
    },
    {
      key: '2',
      label: 'Streams',
      children: <StreamUnitTable units={data?.edges} type={TableType.Stream} reload={reload} />,
    }
  ]
  
  return <div className="unit-container">
    <div className={'unit-header flex-space-btw'}>
      <div>Simulation Units</div>
    </div>
    <div className="p-1">
      <Tabs defaultActiveKey="1" items={tabs} style={{width: '100%'}} />
    </div>
  </div>
}